import React from 'react';
import Modal from 'components/modal/modal.component';
import GoogleDocViewer from '../../../components/google-doc-viewer/google-doc-viewer.component';
import { DOCS } from '../../../constants/docs.constants';

interface IProps {
  docType: 'processingPersonalDataConsent' | 'userAgreement';
  handleClose: () => void;
}

const ConfirmDocModal: React.FC<IProps> = ({ docType, handleClose }) => {
  return (
    <Modal width={'800px'} withoutPadding={true} onClose={() => handleClose()}>
      <GoogleDocViewer
        docId={
          docType === 'processingPersonalDataConsent'
            ? DOCS.PROCESSING_PERSONAL_DATA_CONSENT
            : DOCS.USER_AGREEMENT
        }
        height={500}
      />
    </Modal>
  );
};

export default ConfirmDocModal;
